import { getAllPackages } from "@/api/backgroundCheck";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

export interface Package {
  pkg_id: string;
  name: string;
  description: string;
  price: number;
  is_ny: boolean;
  document_ids: string[];
  created_at: string;
  updated_at: string;
  __v: number;
  for_js: boolean;
  order: number;
  kred_pkg_id: string;
  id: string;
}

interface PackagesState {
  allPackages: Package[];
  selectedPackage: Package | null; // Add selectedPackage here
  loading: boolean;
  error: string | null;
}

const initialState: PackagesState = {
  allPackages: [],
  selectedPackage: null, // Default to null
  loading: false,
  error: null,
};

// Async thunk for fetching packages
export const getPackagesAction = createAsyncThunk(
  "package/getPackages",
  async (userType: "employer" | "jobseeker", { rejectWithValue }) => {
    try {
      const response = await getAllPackages(userType);
      return response.result;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch packages");
    }
  }
);

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    // Add a new reducer to set the selected package
    setSelectedPackage: (state, action: PayloadAction<Package>) => {
      state.selectedPackage = action.payload;
    },
    // Optional: Add a reducer to clear the selected package
    clearSelectedPackage: (state) => {
      state.selectedPackage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPackagesAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPackagesAction.fulfilled, (state, action: PayloadAction<Package[]>) => {
        state.allPackages = action.payload;
        state.loading = false;
      })
      .addCase(getPackagesAction.rejected, (state, action: PayloadAction<any>) => {
        state.error = action.payload || "Something went wrong";
        state.loading = false;
      });
  },
});

export const { setSelectedPackage, clearSelectedPackage } = packageSlice.actions;

export default packageSlice.reducer;
